import * as _ from "lodash";

import Tac from "./Tac";

export default class Features {
    public static is(name: string): boolean {
        return /^hosts\/\d+\/galleries\/\d+\/features$/.test(name);
    }

    public static fromData(data: any): Features {
        if (!data) {
            throw new Error("Features.fromData requires data");
        }

        if (!_.isUndefined(data.phone) && !_.isBoolean(data.phone)) {
            throw new Error("Features.fromData data.phone should be a boolean");
        }
        if (!_.isUndefined(data.email) && !_.isBoolean(data.email)) {
            throw new Error("Features.fromData data.email should be a boolean");
        }
        if (!_.isUndefined(data.hashtag) && !_.isBoolean(data.hashtag)) {
            throw new Error("Features.fromData data.hashtag should be a boolean");
        }
        if (!_.isUndefined(data.upload) && !_.isBoolean(data.upload)) {
            throw new Error("Features.fromData data.upload should be a boolean");
        }
        if (!_.isUndefined(data.optimize_images) && !_.isBoolean(data.optimize_images)) {
            throw new Error("Features.fromData data.optimize_images should be a boolean");
        }
        if (!_.isUndefined(data.analyze_iamges) && !_.isBoolean(data.analyze_images)) {
            throw new Error("Features.fromData data.analyze_images should be a boolean");
        }
        if (!_.isUndefined(data.max_adult) && !_.isNumber(data.max_adult)) {
            throw new Error("Features.fromData data.max_adult should be a number");
        }
        if (!_.isUndefined(data.max_spoof) && !_.isNumber(data.max_spoof)) {
            throw new Error("Features.fromData data.max_spoof should be a number");
        }
        if (!_.isUndefined(data.max_violence) && !_.isNumber(data.max_violence)) {
            throw new Error("Features.fromData data.max_violence should be a number");
        }
        if (!_.isUndefined(data.max_medical) && !_.isNumber(data.max_medical)) {
            throw new Error("Features.fromData data.max_medical should be a number");
        }
        if (!_.isUndefined(data.vulgar_check) && !_.isBoolean(data.vulgar_check)) {
            throw new Error("Features.fromData data.vulgar_check should be a boolean");
        }
        if (!_.isUndefined(data.sentiment_check) && !_.isBoolean(data.sentiment_check)) {
            throw new Error("Features.fromData data.sentiment_check should be a boolean");
        }
        if (!_.isUndefined(data.min_sentiment) && !_.isNumber(data.min_sentiment)) {
            throw new Error("Features.fromData data.min_sentiment should be a number");
        }
        if (!_.isUndefined(data.download_all) && !_.isNumber(data.download_all)) {
            throw new Error("Features.fromData data.download_all should be a boolean");
        }

        return new Features(
            data.phone,
            data.email,
            data.hashtag,
            data.upload,
            data.optimize_images,
            data.analyze_images,
            data.max_adult,
            data.max_spoof,
            data.max_violence,
            data.max_medical,
            data.vulgar_check,
            data.sentiment_check,
            data.min_sentiment,
            data.download_all,
        );
    }

    // ingress
    public phone: boolean;
    public email: boolean;
    public hashtag: boolean;
    public upload: boolean;

    // image
    public optimize_images: boolean;
    public analyze_images: boolean;
    public max_adult: number;
    public max_spoof: number;
    public max_violence: number;
    public max_medical: number;
    public min_original_image_size: number;

    // note
    public vulgar_check: boolean;
    public sentiment_check: boolean;
    public min_sentiment: number;

    // egress
    public download_all: boolean;

    constructor (
        phone?: boolean,
        email?: boolean,
        hashtag?: boolean,
        upload?: boolean,
        optimize_images?: boolean,
        analyze_images?: boolean,
        max_adult?: number,
        max_spoof?: number,
        max_violence?: number,
        max_medical?: number,
        vulgar_check?: boolean,
        sentiment_check?: boolean,
        min_sentiment?: number,
        download_all?: boolean,
    ) {
        this.phone = _.isBoolean(phone) ? phone : true;
        this.email = _.isBoolean(email) ? email : false;
        this.hashtag = _.isBoolean(hashtag) ? hashtag : false;
        this.upload = _.isBoolean(upload) ? upload : true;
        this.optimize_images = _.isBoolean(optimize_images) ? optimize_images : true;
        this.analyze_images = _.isBoolean(analyze_images) ? analyze_images : true;
        this.max_adult = _.isNumber(max_adult) ? max_adult : 3;
        this.max_spoof = _.isNumber(max_spoof) ? max_spoof : 3;
        this.max_violence = _.isNumber(max_violence) ? max_violence : 3;
        this.max_medical = _.isNumber(max_medical) ? max_medical : 3;
        this.vulgar_check = _.isBoolean(vulgar_check) ? vulgar_check : true;
        this.sentiment_check = _.isBoolean(sentiment_check) ? sentiment_check : true;
        this.min_sentiment = _.isNumber(min_sentiment) ? min_sentiment : -0.5;
        this.download_all = _.isBoolean(download_all) ? download_all : true;

        this.min_original_image_size = 40000;
    }

    public isLowRes(tac: Tac): boolean {
        if (tac.image && tac.image.original && tac.image.original.size) {
            return tac.image.original.size < this.min_original_image_size;
        }
        return false;
    }

    public quarantine(tac: Tac): boolean {
        if (tac.image && tac.image.analysis) {
            if (tac.image.analysis.adult > this.max_adult) {
                return true;
            }
            if (tac.image.analysis.spoof > this.max_spoof) {
                return true;
            }
            if (tac.image.analysis.violence > this.max_violence) {
                return true;
            }
            if (tac.image.analysis.medical > this.max_medical) {
                return true;
            }
        }
        if (this.isLowRes(tac)) {
            return true;
        }
        if (tac.note && tac.note.sentiment) {
            if (tac.note.sentiment.score < this.min_sentiment) {
                return true;
            }
        }
        if (tac.note && tac.note.vulgar && tac.note.vulgar.matches && tac.note.vulgar.matches.length) {
            return true
        }
        // magic for tour until we get textual analysis
        if (tac.note && tac.note.text === "Gross, what an ugly dress") {
            return true;
        }

        return false;
    }
}
